var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app--triangle-container",style:({
		transform: 'translateX(' + _vm.offset + '%)',
		visibility: _vm.display ? 'visible': 'hidden'
		}),attrs:{"data-type":_vm.type}},[_c('div',{class:{
		'app--triangle-down': _vm.type==='down',
		'app--triangle-up': _vm.type==='up',
		'app--triangle-down-blue': _vm.type==='down' && _vm.hasStyle,
		'app--triangle-up-red': _vm.type==='up' && _vm.hasStyle
		}})])}
var staticRenderFns = []

export { render, staticRenderFns }